export default {
  setTractHudSections (state, tractHudSections) {
    state.tractHudSections = tractHudSections
  },

  setTractHudSectionsLoading (state, loading) {
    state.loading = loading
  }
}
